import { getAccessToken } from 'axios-jwt';
import { BASE_URL } from '@/Constants';

export async function loadTimeMetricsStream(
  cuSerialNumber: string,
  tsFrom: number,
  tsTo: number,
  tz: string,
) {
  const accessToken = await getAccessToken();

  const response = await fetch(
    `${BASE_URL}/metrics/oee/time/${cuSerialNumber}?ts_from=${tsFrom}&ts_to=${tsTo}&tz=${tz}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  if (response.status === 403) {
    window.location.reload();
  }

  if (!response.ok || !response.body) {
    throw new Error('Streaming request failed');
  }

  return response;
}

export async function loadCountMetricsStream(
  cuSerialNumber: string,
  tsFrom: number,
  tsTo: number,
  tz: string,
) {
  const accessToken = await getAccessToken();

  const response = await fetch(
    `${BASE_URL}/metrics/oee/count/${cuSerialNumber}?ts_from=${tsFrom}&ts_to=${tsTo}&tz=${tz}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  if (response.status === 403) {
    window.location.reload();
  }

  if (!response.ok || !response.body) {
    throw new Error('Streaming request failed');
  }

  return response;
}

export type ExportFileType = 'all' | 'state_sequence' | 'count_events';

export async function exportMetricsData(
  cuSerialNumber: string,
  tsFrom: number,
  tsTo: number,
  tz: string,
  fileType: ExportFileType = 'all',
) {
  const accessToken = await getAccessToken();

  const response = await fetch(
    `${BASE_URL}/metrics/oee/export/${cuSerialNumber}?ts_from=${tsFrom}&ts_to=${tsTo}&tz=${tz}&file_type=${fileType}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  if (response.status === 403) {
    window.location.reload();
  }

  if (!response.ok) {
    throw new Error('Export request failed');
  }

  let filename = '';
  if (fileType === 'all') {
    filename = `metrics_export_${cuSerialNumber}_${tsFrom}_${tsTo}.zip`;
  } else if (fileType === 'state_sequence') {
    filename = `state_sequence_${cuSerialNumber}_${tsFrom}_${tsTo}.csv`;
  } else if (fileType === 'count_events') {
    filename = `count_events_${cuSerialNumber}_${tsFrom}_${tsTo}.csv`;
  }

  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
